module.exports = __webpack_public_path__ + "img/59-d28282.png";